/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

import NewContentList from "./NewContentList";

import "../../css/event20201221.css";

class Event20201221_newContent extends Component {
  _onPass = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push("/ticket");
  };
  _onSns = (sns) => {
    //alert('서비스를 등록중입니다. 잠시만 기다려 주세요')
    //return;

    if (sns === "f") {
      window.open(
        "https://www.facebook.com/aniplushd/posts/3553320331451965",
        "",
        ""
      );
    } else if (sns === "t") {
      window.open(
        "https://twitter.com/ANIPLUSTV/status/1343497744896327680",
        "",
        ""
      );
    } else {
      window.open(
        "https://www.youtube.com/post/UgxgYa7oJ4AnTE1O1B14AaABCQ",
        "",
        ""
      );
    }
  };
  _goWeekTimeline = () => {
    const { setTimelineWeek } = this.props;
    setTimelineWeek(true);
  };
  render() {
    return (
      <Fragment>
        <div className="detil_top" style={{ marginTop: -40 }} id="top">
          <div className="event201218">
            <div className="sticky">
              <div className="quick">
                <a href="#top">
                  <img src="/img/event/20201218/quick01.png" alt="top" />
                </a>
                <a href="#newList">
                  <img src="/img/event/20201218/quick02.png" alt="신작목록" />
                </a>
                <a href="#event01">
                  <img src="/img/event/20201218/quick03.png" alt="이벤트01" />
                </a>
                <a href="#event02">
                  <img src="/img/event/20201218/quick04.png" alt="이벤트02" />
                </a>
                <a onClick={this._goWeekTimeline} style={{ cursor: "pointer" }}>
                  <img src="/img/event/20201218/quick05.png" alt="편성표" />
                </a>
              </div>
            </div>
            <div className="fl_ico link">
              <a onClick={this._onPass} style={{ cursor: "pointer" }}>
                바로가기
              </a>
              <img
                src="/img/event/20201218/fl_ico02.png"
                alt="30일 무료체험 바로가기"
              />
            </div>

            <div className="fl_ico like">
              <img src="/img/event/20201218/fl_ico01.png" />
            </div>
            <img src="/img/event/20201218/event01_01.png" />
            <div id="event01">
              <img src="/img/event/20201218/event01_02.png" />
            </div>

            <div id="newList">
              <div className="fl_ico heart">
                <img src="/img/event/20201218/fl_ico03.png" />
              </div>
              <h3 className="tit">
                <img
                  src="/img/event/20201218/tit01.png"
                  alt="애니플러스 1분기 신작 라인업 "
                />
                <span>
                  너에게 닿기를… 보고 싶은 신작을 지인에게 공유해주세요!
                </span>
              </h3>

              <NewContentList sameCode={202101} />

              <button type="button" onClick={this._goWeekTimeline}>
                <span>
                  신작 LIVE / TV 요일별 시간표 보기{" "}
                  <img src="/img/event/20201218/arrow.png" />
                </span>
                <img src="/img/event/20201218/btn02.png" />
              </button>
            </div>
            <div id="event02">
              <div className="fl_ico mail">
                <img src="/img/event/20201218/fl_ico04.png" />
              </div>
              <div className="fl_ico twit">
                <img src="/img/event/20201218/fl_ico05.png" />
              </div>
              <img src="/img/event/20201218/event02.png" />
              <div className="linkArea">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this._onSns("f")}
                  alt="페이스북 참여하기"
                ></a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this._onSns("t")}
                  alt="트위터 참여하기"
                ></a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this._onSns("u")}
                  alt="유튜브 참여하기"
                ></a>
              </div>
            </div>
            <div>
              <img src="/img/event/20201218/event03.png" />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20201221_newContent));
